import { useRecoilState } from "recoil";
import { message } from "../atom";

const useMessageState = () => {
    return useRecoilState(message);
};

export default useMessageState;